import { emptyStaticProps } from '@/lib/web/common-ssr';

const ShareEventPrivacyPage = () => {
  return (
    <div className={'app-side-padding pt-8'}>
      <h1 className={'heading-6 mb-4'}>비즈넵 환급 이벤트 개인정보 수집 및 이용 동의</h1>
      <div className={'text-sm text-gray-600'}>시행일자: 2024-08-01</div>
      <article className={'w-full max-w-4xl pb-24 pt-4 md:pt-8 lg:pt-12'}>
        <h2 className={'heading-7 mb-[1em] font-extrabold'}>개인정보 수집·이용 동의서</h2>
        <p className={'text-sm text-gray-600'}>
          지엔터프라이즈(주)(이하 ‘회사’)가 제공하는 서비스 ‘비즈넵 환급’(이하 ‘서비스’)은 본 이벤트 운영을 위하여 귀하의 개인 정보를 수집 및 이용합니다.
        </p>
        <table className={'paragraph-6 mb-[1em] mt-[2em] w-full border-gray-100'}>
          <thead>
            <tr className={'font-semibold'}>
              <th className={'border bg-[#f0eeff] px-2 py-2.5 text-center'}>개인정보 수집 항목</th>
              <th className={'border bg-[#f0eeff] px-2 py-2.5 text-center'}>개인정보 수집 이용 목적</th>
              <th className={'border bg-[#f0eeff] px-2 py-2.5 text-center'}>보유 및 이용기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={'border px-2 py-2.5 text-center'}>휴대폰번호, 이메일, 고객명</td>
              <td className={'border px-2 py-2.5 text-center'}>이벤트 참가자 식별 및 경품 발송</td>
              <td className={'border px-2 py-2.5 text-center'}>이벤트 종료 후 즉시 파기</td>
            </tr>
          </tbody>
        </table>
        <p className={'text-sm text-gray-600'}>
          ※ 귀하는 위 개인정보의 수집 및 이용에 대한 동의를 거부할 수 있습니다. 다만 동의를 거부할 경우 이벤트 참여 및 경품 발송에 제한이 있습니다.
        </p>
      </article>
    </div>
  );
};

export const getStaticProps = emptyStaticProps;

export default ShareEventPrivacyPage;
